define(function (require) {
    var avalon = require('avalon'),
        ajax = require('ajax'),
        dialog = require('dialog'),
        tool = require('toolLoaderPC'),
        $ = require('jquery');
    /* eslint-disable */
    var hiddenValues,
        selectedArray = [],
        plusLoading = false,
        minusLoading = false;

    function inSelected(id) {
        var selected = vmodel.selected,
            res = false;
        $.each(selected, function (i, _id) {
            if (id === _id) {
                res = true;
                return false;
            }
        });
        return res;
    }

    function validate(group) {
        var total = group.can_buy,
            res = {
                count: 0,
                totalPrice: 0,
                freight: 0,
                flag: true,
            },
            freight_cut_money = tool.toNumber(group.freight_cut_money);
        $.each(group.sku, function (i, goods) {
            if (inSelected(goods.sku_id)) {
                res.count += tool.toNumber(goods.nums);
                res.totalPrice += goods.nums * tool.toNumber(goods.shop_price);
                res.freight = tool.toNumber(group.freight);
                if (tool.toNumber(goods.nums) !== 0) {
                    selectedArray.push(goods.sku_id.toString());
                }

                if (goods.nums > goods.number) {
                    res.flag = false;
                }
            }
        });

        if (freight_cut_money !== 0 && res.totalPrice >= freight_cut_money) {
            res.freight = 0;
        }

        //如果超过库存或者超过最大购买数量
        if (group.restrict && res.flag == true) {
            //限购
            res.flag = res.count <= total;
        } else if (res.flag == true) {
            res.flag = true;
        }

        return res;
    }

    function update() {
        selectedArray = [];

        var selected = vmodel.selected,
            list = vmodel.list,
            res = true,
            count = 0,
            totalPrice = 0,
            totalFreight = 0;

        $.each(list, function (i, group) {
            var v = validate(group);
            count += v.count;
            totalPrice += v.totalPrice;
            totalFreight += v.freight;
            if (!v.flag) {
                group.red = true;
                res = false;
            } else {
                group.red = false;
            }
        });

        vmodel.count = count;
        vmodel.totalPrice = tool.toMoney(totalPrice);
        vmodel.totalFreight = tool.toMoney(totalFreight);
        return res;
    }

    var vmodel = avalon.define({
        $id: 'cartController',
        list: [],
        count: 0, // 选了多少件商品,
        totalPrice: '0.00', // 总价是多少
        totalFreight: '0.00', // 总运费是多少

        //埋点数据统计
        sendEventTracking: function (n) {
            tool.sendEventTracking('pc', n);
        },

        selected: [],
        selectedChange: function () {
            vmodel.selectedAll = [];
            update();
        },

        selectedAll: [],
        selectAllChange: function () {
            if (vmodel.selectedAll.length) {
                $.each(vmodel.list, function (i, group) {
                    $.each(group.sku, function (i, goods) {
                        vmodel.selected.push(goods.sku_id);
                    });
                });
            } else {
                vmodel.selected = [];
            }
            update();
        },

        //
        submitLoading: false,
        submit: function () {
            if (vmodel.submitLoading === true) {
                return;
            } else if (selectedArray.length === 0) {
                dialog.alert('请至少选择一件商品');
            } else if (!update()) {
                dialog.alert('商品超过限购数量，请减少商品数量');
            } else {
                vmodel.sendEventTracking(10600);
                ajax.jump(
                    'order_clearing.html?skus=' + selectedArray.join('_'),
                );
            }
        },

        // 商品数量操作
        changeNums: function (goods, type) {
            // 购买数量不能超过最大购买量
            if ($(this).hasClass('disabled')) {
                return;
            }

            var goods_num = tool.toNumber(goods.nums) + tool.toNumber(type);
            if (goods_num > goods.number) {
                goods_num = goods.number;
            }

            // 购买数量不能小于1
            if (tool.toNumber(goods_num) < 1) return;

            tool.singleWay('get-register', function (key) {
                minusLoading = this;

                ajax
                    .postWithFail('add_to_cart.html', {
                        //action: 'minus',
                        sku_id: goods.sku_id,
                        nums: goods_num,
                    })
                    .done(function (response) {
                        if (response.type === 'succ') {
                            goods.nums = goods_num;
                            update();
                        }

                        minusLoading.resolve(key);
                    })
                    .fail(function () {
                        minusLoading.resolve(key);
                    });
            });
        },

        countPrice: function (goods) {
            var price = tool.toNumber(goods.shop_price);
            var nums = tool.toNumber(goods.nums);
            return tool.toMoney(price * nums);
        },

        // 删除商品
        deleteGoods: function (goods, group) {
            dialog.confirm('确认删除该商品吗？', function () {
                ajax.getWithFail(goods.delete_url).done(function () {
                    group.sku.remove(goods);
                    vmodel.selected.remove(goods.sku_id);
                    update();
                });
            });
        },
    });

    return {
        init: function () {
            hiddenValues = tool.getHiddenValues('#js-local-hiddens');

            $.each(hiddenValues.cart_list, function (i, group) {
                group.red = false;
                // group.restrict = !(tool.toNumber(group.can_buy) === -1);
                group.tips = '';

                if (group.ip_restrict == '0') {
                    group.hint = '本商品不限购';
                    group.can_buy = -1;
                    group.restrict = false;
                } else {
                    group.hint =
                        '本商品每人限购' +
                        group.ip_restrict +
                        '件，您已购买' +
                        group.purchased +
                        '件';
                    group.can_buy =
                        tool.toNumber(group.ip_restrict) -
                        tool.toNumber(group.purchased);
                    group.restrict = true;
                }

                $.each(group.sku, function (i, sku) {
                    sku.nums = tool.toNumber(sku.buy_num); //当前购买数量
                    sku.groupid = group.id;
                });
            });
            vmodel.list = hiddenValues.cart_list;
            vmodel.selectedAll = ['on'];
            vmodel.selectAllChange();

            vmodel.sendEventTracking(10500);

            setTimeout(function () {
                $('#pjax-container .personal-aside').css('height', 'auto');
                tool.fixHeight(
                    $('#pjax-container .container'),
                    $('#pjax-container .personal-aside'),
                );
            }, 0);
        },
        clear: function () {
            vmodel.list = [];
            vmodel.count = 0; // 选了多少件商品,
            vmodel.totalPrice = '0.00'; // 总价是多少
            vmodel.totalFreight = '0.00'; // 总运费是多少
            vmodel.selected = [];
            vmodel.selectedAll = [];
            plusLoading = false;
            minusLoading = false;
        },
    };
});



// WEBPACK FOOTER //
// ./src/js_modules/cartController.js